import { render, staticRenderFns } from "./recommendCode.vue?vue&type=template&id=691cf39f&scoped=true&"
import script from "./recommendCode.js?vue&type=script&lang=js&"
export * from "./recommendCode.js?vue&type=script&lang=js&"
import style0 from "./recommendCode.css?vue&type=style&index=0&id=691cf39f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691cf39f",
  null
  
)

export default component.exports